import '../css/infospratiques.css';

export default function InfosPratiques() {
  return (
    <div>
      <h1>Infos pratiques</h1>

      {/* <div style={{ width: "auto" }}>
        <h2><strong>Adresse : </strong> Amar et Hôtes<br />
          Rue de l'Abattoir 34, 5060 Sambreville</h2>
        <div style={{ width: "100%", textAlign: "center", padding: "10px 0" }}>
          <img src="/images/amar-hotes.jpg" alt="Lieu" />
        </div>
      </div> */}

      {/* <div className="info-block">
        <p className="info-title">Adresse : Amar et Hôtes</p>
        <p className="info-address">Rue de l'Abattoir 34, 5060 Sambreville</p>

        <img src="/images/amar-hotes.jpg" alt="Amar et Hôtes" className="info-photo" />
      </div> */}

      <div className="info-container">
        <div className="info-text">
          <h2>Adresse : Amar et Hôtes <br/>
          Rue de l'Abattoir 34, 5060 Sambreville</h2>
        </div>

        <img src="images/amar-hotes.jpg" alt="Amar et Hôtes" className="info-photo" />
      </div>


      <h2>Date : Le 16 mai 2026 à partir de 14h</h2>

      <p>Parking : les informations viendront prochainement</p>

      <p> 3 technicomic (personnes ressources) dont la tête est affichée à l'entrée
        - toute la journée pour organiser</p>
      <p> Dress code "habille toi comme tu as envie" (n'achetez pas du neuf)</p>

    </div>
  );
}

